var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5928 3.02719C14.6806 2.04234 13.4065 1.5 12.0003 1.5C10.5865 1.5 9.30824 2.03906 8.40027 3.01781C7.48246 4.00734 7.03527 5.35219 7.14027 6.80437C7.34839 9.66937 9.52855 12 12.0003 12C14.472 12 16.6484 9.66984 16.8598 6.80531C16.9662 5.36625 16.5162 4.02422 15.5928 3.02719Z",
    fill: "#E2F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2503 22.5H3.75027C3.5343 22.5028 3.32042 22.4574 3.12419 22.3672C2.92796 22.2769 2.75432 22.1441 2.61589 21.9783C2.31121 21.6141 2.18839 21.1167 2.27933 20.6137C2.67496 18.4191 3.90964 16.5755 5.85027 15.2812C7.57433 14.1323 9.75824 13.5 12.0003 13.5C14.2423 13.5 16.4262 14.1328 18.1503 15.2812C20.0909 16.575 21.3256 18.4186 21.7212 20.6133C21.8121 21.1162 21.6893 21.6136 21.3846 21.9778C21.2463 22.1437 21.0726 22.2766 20.8764 22.367C20.6802 22.4573 20.4663 22.5028 20.2503 22.5Z",
    fill: "#E2F7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person_icon.f76591594125d6e64526ec0098b9a963.svg";
export { ForwardRef as ReactComponent };